import SearchApi from 'js-worker-search';

const searchApi = new SearchApi();

export const { indexDocument, search } = searchApi;
